<template>
  <div>
    <div class="b-import pb-4">
      <div class="b-import__panel b-form">
        <div class="b-import__save-template mb-2">
          <dynamic-icon class="mr-1" icon="info" />
          <div class="mr-1">{{$t('CONTENT.importData.import_template_text')}}</div>
          <button @click.prevent="downloadEmptyTemplate" class="b-import__template-btn">
            {{$t('CONTENT.importData.import_template_btn')}}
          </button>
        </div>
        <div class="b-import__save-template mb-4">
          <dynamic-icon class="mr-1" icon="info" />
          <div class="mr-1">{{$t('CONTENT.importData.available')}}</div>
          <button @click.prevent="downloadCurrentManualChartsTemplate" class="b-import__template-btn">
            {{$t('CONTENT.importData.current_contract_version')}}
          </button>
        </div>
        <div class="row b-import__panel-btn">
          <file-upload
            :importType="importType"
            :assetComponent=assetComponent
            @finishUpload="onFinishUpload"
            @uploadError="onUploadError">
          </file-upload>
        </div>
      </div>
      <server-error :error="error"/>
    </div>
  </div>
</template>

<script>
  import downloadFileMixin from '../../../../mixins/downloadFile';
  import SetManualChart from "../../models/commands/SetManualChart";

  export default {
    mixins: [downloadFileMixin],
    props: ['assetComponent', 'assetComponentName'],
    data() {
      return {
        error: null,
        importErrors: [],
        importDuplicateErrors: [],
        importImported: 0,
        importType: 'manualChart',
        manualChartsForDownload: [],
        manualChartsResponse: null
      }
    },
    methods: {
      downloadEmptyTemplate() {
        this.manualChartsForDownload = [];
        this.downloadTemplate();
      },
      downloadCurrentManualChartsTemplate() {
        this.manualChartsForDownload = [];
        this.manualChartsForDownload = this.assetComponent.manualChartPayments;
        this.downloadTemplate();
      },
      async onFinishUpload(response) {
        this.error = null;
        this.manualChartsResponse = response;
      },
      onUploadError(error) {
        if(error !== undefined) {
          this.error = error;
        }
      },
      cancel() {
        this.manualChartsForDownload = [];
        this.manualChartsResponse = null;
      },
      save() {
        const command = new SetManualChart(
          this.assetComponentName,
          this.manualChartsResponse
        );
        this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
        return true;
      }
    }
  }
</script>
